import {useAtom} from 'jotai';
import sanitize from 'sanitize-html';
import styled from 'styled-components';
import {typographyStyle} from '@/components/Typography';
import {internalToastAtom} from '@/map/atom';
import {IconClose} from '@/styled-components';
import {LAYOUT_SIZE, LAYOUT_Z_INDEX, palette} from '@/styles';

export const InternalToaster = () => {
  const [message, setInternalToast] = useAtom(internalToastAtom);

  if (!message) return null;

  return (
    <Toaster>
      <Toast>
        <span dangerouslySetInnerHTML={{__html: sanitize(message)}} />
        <IconClose onClick={() => setInternalToast(null)} />
      </Toast>
    </Toaster>
  );
};

const Toaster = styled.div`
  position: absolute;
  z-index: ${LAYOUT_Z_INDEX.NAVBAR};
  top: ${LAYOUT_SIZE.MOBILE_MAP_TOP_BAR_HEIGHT + 16}px;
  left: 50%;
  transform: translateX(-50%);
`;

const Toast = styled.div`
  border-radius: 5px;
  border: 1px solid ${palette.gray200};
  background: ${palette.white};
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);
  padding: 14px 12px 14px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  max-width: 90vw;
  width: max-content;
  word-break: break-word;
  flex-shrink: 0;
  gap: 8px;
  color: ${palette.gray800};
  ${{...typographyStyle.medium14}};
`;
